export default __webpack_public_path__ + "img/7d3015aa9852b03d86572eb1781b1eff.png";